"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const chatSlice_1 = require("../../redux/slices/chatSlice");
const userSlice_1 = require("../../redux/slices/userSlice");
const chatSlice_2 = require("../../redux/slices/chatSlice");
const chatList_1 = __importDefault(require("./components/chatList/chatList"));
const singleChat_1 = __importDefault(require("./components/singleChat/singleChat"));
const socket_1 = __importDefault(require("./utils/socket"));
require("./app.scss");
class App extends react_1.default.Component {
    componentDidMount() {
        this.props.getUser();
        this.socket = new socket_1.default();
        this.socket.init();
        window.AppearMe.Widgets.Events.subscribe('onChatDeSelect', (e) => this.props.deSelectChat());
    }
    componentWillUnmount() {
        this.socket.deregister();
    }
    render() {
        const { activeChat } = this.props.chat;
        return (react_1.default.createElement(react_1.Fragment, null, !activeChat ? react_1.default.createElement(chatList_1.default, null) : react_1.default.createElement(singleChat_1.default, { case: activeChat })));
    }
}
const mapStateToProps = (state) => {
    const { chat } = state;
    return {
        chat
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        resetState: () => dispatch(chatSlice_1.resetState()),
        resetUser: () => dispatch(userSlice_1.resetUser()),
        getUser: () => dispatch(userSlice_1.getUser()),
        deSelectChat: () => dispatch(chatSlice_2.deSelectChat())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(App);
